const topics = [
  { tag: '#古装权谋', heat: '128万讨论', desc: '朝堂风云再起', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { tag: '#都市情感', heat: '96万讨论', desc: '成年人的爱情故事', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { tag: '#悬疑反转', heat: '87万讨论', desc: '烧脑神剧停不下来', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
  { tag: '#韩剧虐恋', heat: '74万讨论', desc: '虐心催泪弹', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { tag: '#美剧科幻', heat: '63万讨论', desc: '未来世界奇观', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { tag: '#甜宠剧场', heat: '58万讨论', desc: '糖分超标警告', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
  { tag: '#年代怀旧', heat: '45万讨论', desc: '回到过去的美好', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { tag: '#仙侠奇幻', heat: '41万讨论', desc: '御剑飞行闯三界', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { tag: '#犯罪纪实', heat: '33万讨论', desc: '真实案件改编', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            话题热议
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            全网剧迷都在讨论什么？看看大家都在追哪些热门电视剧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topics.map((topic) => (
            <div
              key={topic.tag}
              className={`flex items-start gap-4 p-4 md:p-5 rounded-xl border ${topic.color} cursor-pointer transition-all duration-300 hover:scale-[1.02]`}
            >
              <div className="flex-1 min-w-0">
                <span className="inline-block text-sm md:text-base font-bold mb-1">{topic.tag}</span>
                <p className="text-xs md:text-sm opacity-80 mb-2">{topic.desc}</p>
                <span className="text-xs opacity-60">{topic.heat}</span>
              </div>
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-lg opacity-60"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}